
import React from 'react';
import { Alert } from '../components/atoms/alert';
import { CopyToClipboard } from '../components/atoms/copyToClipboard';
import { Device } from '../interfaces';
import { DevicesService } from '../services/devices.service';

export const getDeviceIPModal = (device: Pick<Device, 'id'>) => (evt?: any) => {
  DevicesService.getDeviceVPNIp(device.id).then(async (res) => {
    new Alert(<CopyToClipboard children={res} />).promise;
  });

  evt?.stopPropagation();
  evt?.preventDefault();
};
